import { get } from './request.js';

const resourceName = 'user-privacy-policies';

export function index(params) {
  return get({
    url: resourceName,
    params,
  });
}



// WEBPACK FOOTER //
// ./src/api/user-privacy-policy.js